/* Tandem — cart-drawer.js v3
   AJAX cart drawer: ATC, +/-, quitar, open/close + UpCart-tier modules:
   - Countdown al cut-off 18:00
   - Delivery date dinámica
   - Announcement rotativa
   - Add-on toggle protección envío
   - Discount code box colapsable
   ---------------------------------------------------------- */
(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var cartBody = drawer.querySelector('[data-cart-body]');
  var cartFooter = drawer.querySelector('[data-cart-footer]');
  var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  var ctaTotalEl = drawer.querySelector('[data-cart-cta-total]');
  var savingsEl = drawer.querySelector('[data-cart-savings]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  var countdownEl = drawer.querySelector('[data-cart-countdown]');
  var countdownHeadline = drawer.querySelector('[data-countdown-headline]');
  var countdownTimer = drawer.querySelector('[data-countdown-timer]');
  var deliveryDateEl = drawer.querySelector('[data-delivery-date]');
  var announcements = drawer.querySelectorAll('[data-announcement]');
  var addonEl = drawer.querySelector('[data-cart-addon]');
  var addonInput = drawer.querySelector('[data-cart-addon-input]');
  var reviewEl = drawer.querySelector('.cart-drawer__review');
  var discountEl = drawer.querySelector('.cart-drawer__discount');

  var FALLBACK_NAME = 'Tandem · Correa doble';
  var MONTHS_ES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var WEEKDAYS_ES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  function formatMoneyEUR(cents) {
    var val = (cents / 100).toFixed(2).replace('.', ',');
    val = val.replace(/,00$/, '');
    return val + ' €';
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeUrl(str) {
    if (!str) return '';
    try {
      var u = new URL(str, window.location.origin);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return '';
      return u.href.replace(/"/g, '%22');
    } catch (e) {
      return '';
    }
  }

  function openDrawer() {
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function trackMetaEvent(name, payload) {
    if (window.fbq) window.fbq('track', name, payload || {});
    if (window.gtag) window.gtag('event', name, payload || {});
    if (window.ttq) window.ttq.track(name, payload || {});
  }

  function toggleEmptyUI(hasItems) {
    if (countdownEl) countdownEl.hidden = !hasItems;
    if (addonEl) addonEl.hidden = !hasItems;
    if (reviewEl) reviewEl.hidden = !hasItems;
    if (discountEl) discountEl.hidden = !hasItems;
  }

  // Reflect add-on state in checkbox based on cart contents
  function syncAddonState(cart) {
    if (!addonInput) return;
    var addonId = addonInput.getAttribute('data-addon-id');
    if (!addonId) return;
    var present = (cart.items || []).some(function (it) {
      return String(it.variant_id) === String(addonId) || String(it.id) === String(addonId);
    });
    addonInput.checked = present;
  }

  function renderCart(cart) {
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count === 0) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    });

    // Sync floating cart button visibility (hide if cart empty)
    document.querySelectorAll('[data-floating-cart]').forEach(function (btn) {
      if (cart.item_count === 0) btn.setAttribute('hidden', '');
      else btn.removeAttribute('hidden');
    });

    toggleEmptyUI(cart.item_count > 0);
    syncAddonState(cart);

    if (cart.item_count === 0) {
      // Build empty state via safe DOM creation (no innerHTML of dynamic content)
      cartBody.textContent = '';
      var emptyWrap = document.createElement('div');
      emptyWrap.className = 'cart-drawer__empty';
      emptyWrap.setAttribute('data-cart-empty', '');
      var emptySvgNs = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(emptySvgNs, 'svg');
      svg.setAttribute('viewBox', '0 0 48 48');
      svg.setAttribute('width', '56');
      svg.setAttribute('height', '56');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('aria-hidden', 'true');
      var p1 = document.createElementNS(emptySvgNs, 'path');
      p1.setAttribute('d', 'M15 18h20l-2 14H17L15 18zM19 18V14a5 5 0 0110 0v4');
      p1.setAttribute('stroke', 'currentColor');
      p1.setAttribute('stroke-width', '1.6');
      p1.setAttribute('stroke-linecap', 'round');
      p1.setAttribute('stroke-linejoin', 'round');
      p1.setAttribute('opacity', '0.4');
      svg.appendChild(p1);
      var h3 = document.createElement('h3');
      h3.textContent = 'Tu carrito está vacío';
      var p = document.createElement('p');
      p.textContent = 'Añade tu Tandem para verlo aquí.';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 't-btn t-btn--primary';
      btn.setAttribute('data-cart-close', '');
      btn.textContent = 'Seguir comprando';
      emptyWrap.appendChild(svg);
      emptyWrap.appendChild(h3);
      emptyWrap.appendChild(p);
      emptyWrap.appendChild(btn);
      cartBody.appendChild(emptyWrap);
      cartFooter.hidden = true;
      return;
    }

    cartFooter.hidden = false;
    if (subtotalEl) subtotalEl.textContent = formatMoneyEUR(cart.total_price);
    if (ctaTotalEl) ctaTotalEl.textContent = formatMoneyEUR(cart.total_price);
    if (savingsEl) savingsEl.textContent = formatMoneyEUR(cart.total_discount);

    // Build items via safe DOM manipulation (user data goes through textContent only)
    cartBody.textContent = '';
    var ul = document.createElement('ul');
    ul.className = 'cart-drawer__items';
    ul.setAttribute('data-cart-items', '');

    cart.items.forEach(function (item, i) {
      var imgSrc = item.image ? escapeUrl(item.image.replace(/(\.[^.]+)$/, '_200x$1')) : '';
      var variantRaw = item.options_with_values && item.options_with_values[0]
        ? item.options_with_values[0].value
        : (item.variant_title || '');
      var qty = parseInt(item.quantity, 10) || 0;

      var li = document.createElement('li');
      li.className = 'cart-item';
      li.setAttribute('data-cart-item', '');
      li.setAttribute('data-line', String(i + 1));
      li.setAttribute('data-key', String(item.key));

      var media = document.createElement('div');
      media.className = 'cart-item__media';
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = '';
        img.width = 88;
        img.height = 88;
        img.loading = 'lazy';
        media.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'cart-item__info';
      var name = document.createElement('strong');
      name.className = 'cart-item__name';
      name.textContent = FALLBACK_NAME;
      info.appendChild(name);
      if (variantRaw && variantRaw !== 'Default Title') {
        var vs = document.createElement('span');
        vs.className = 'cart-item__variant';
        vs.textContent = 'Color: ' + variantRaw;
        info.appendChild(vs);
      }
      var bottom = document.createElement('div');
      bottom.className = 'cart-item__bottom';
      var qtyWrap = document.createElement('div');
      qtyWrap.className = 'cart-item__qty';
      var dec = document.createElement('button');
      dec.type = 'button'; dec.className = 'qty-btn';
      dec.setAttribute('data-cart-decrement', '');
      dec.setAttribute('aria-label', 'Reducir cantidad');
      dec.textContent = '−';
      var qtySpan = document.createElement('span');
      qtySpan.setAttribute('data-cart-qty', '');
      qtySpan.textContent = String(qty);
      var inc = document.createElement('button');
      inc.type = 'button'; inc.className = 'qty-btn';
      inc.setAttribute('data-cart-increment', '');
      inc.setAttribute('aria-label', 'Aumentar cantidad');
      inc.textContent = '+';
      qtyWrap.appendChild(dec); qtyWrap.appendChild(qtySpan); qtyWrap.appendChild(inc);
      var priceSpan = document.createElement('span');
      priceSpan.className = 'cart-item__price';
      priceSpan.setAttribute('data-cart-line-price', '');
      priceSpan.textContent = formatMoneyEUR(item.final_line_price);
      bottom.appendChild(qtyWrap); bottom.appendChild(priceSpan);
      info.appendChild(bottom);
      var rm = document.createElement('button');
      rm.type = 'button'; rm.className = 'cart-item__remove';
      rm.setAttribute('data-cart-remove', '');
      rm.textContent = 'Quitar';
      info.appendChild(rm);

      li.appendChild(media);
      li.appendChild(info);
      ul.appendChild(li);
    });

    cartBody.appendChild(ul);

    // Append gifts panel (pre-rendered template clone)
    var giftsTpl = document.getElementById('cart-drawer-gifts-tpl');
    if (giftsTpl && giftsTpl.content) {
      cartBody.appendChild(giftsTpl.content.cloneNode(true));
    }
  }

  async function fetchCart() {
    var res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function addToCart(variantId, quantity) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    });
    if (!res.ok) throw new Error('ATC failed');
    return res.json();
  }

  async function changeQuantity(key, qty) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    return res.json();
  }

  // Delegación global
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      fetchCart().then(renderCart).then(openDrawer);
    }
    if (e.target.closest('[data-cart-close], [data-cart-overlay]')) {
      e.preventDefault();
      closeDrawer();
    }

    var incBtn = e.target.closest('[data-cart-increment]');
    var decBtn = e.target.closest('[data-cart-decrement]');
    var rmBtn = e.target.closest('[data-cart-remove]');

    if (incBtn || decBtn || rmBtn) {
      var item = e.target.closest('[data-cart-item]');
      if (!item) return;
      var key = item.dataset.key;
      var qtyEl = item.querySelector('[data-cart-qty]');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);

      if (incBtn) qty += 1;
      if (decBtn) qty = Math.max(0, qty - 1);
      if (rmBtn) qty = 0;

      changeQuantity(key, qty).then(renderCart);
    }
  });

  // ESC cierra
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.hasAttribute('data-open')) closeDrawer();
  });

  // Intercepta forms ATC (bundle-form legacy + tandem PDP form)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-bundle-form], [data-tandem-atc]');
    if (!form) return;
    e.preventDefault();

    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('[data-atc], button[type="submit"]');
    if (!variantInput || !btn) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    addToCart(variantInput.value, parseInt(qtyInput ? qtyInput.value : '1', 10))
      .then(function (res) {
        trackMetaEvent('AddToCart', {
          content_ids: [variantInput.value],
          content_type: 'product',
          value: res && res.items ? (res.items[0].final_line_price / 100) : 0,
          currency: 'EUR'
        });
        return fetchCart();
      })
      .then(function (cart) {
        renderCart(cart);
        openDrawer();
      })
      .catch(function (err) {
        console.warn('[cart] ATC error', err);
        alert('No se pudo añadir al carrito. Inténtalo de nuevo.');
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });

  // Checkout button → trackea InitiateCheckout
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="/checkout"]');
    if (!link) return;
    fetchCart().then(function (cart) {
      trackMetaEvent('InitiateCheckout', {
        value: cart.total_price / 100,
        currency: 'EUR',
        num_items: cart.item_count
      });
    });
  });

  /* ======================================================
     Countdown al cut-off hoy (default 18:00 Europe/Madrid)
     Si pasa el cut-off → copy "Pedido mañana"
     Siempre basado en reloj local del cliente (no server-side)
     ====================================================== */
  (function initCountdown() {
    if (!countdownEl || !countdownTimer || !countdownHeadline) return;
    var cutoffHour = parseInt(countdownEl.getAttribute('data-cutoff-hour'), 10) || 18;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function nextBusinessDay(from) {
      var d = new Date(from.getTime());
      d.setDate(d.getDate() + 1);
      // skip Sat (6) and Sun (0)
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      return d;
    }

    function tick() {
      var now = new Date();
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0);
      var diff = cutoff - now;
      if (diff > 0) {
        countdownHeadline.textContent = 'Pide antes de las ' + cutoffHour + ':00 · envío HOY';
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        countdownTimer.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      } else {
        var next = nextBusinessDay(now);
        countdownHeadline.textContent = 'Pedido mañana · envío en el próximo día laborable';
        countdownTimer.textContent = WEEKDAYS_ES[next.getDay()] + ' ' + next.getDate() + ' ' + MONTHS_ES[next.getMonth()];
      }
    }

    tick();
    setInterval(tick, 1000);
  })();

  /* ======================================================
     Delivery date estimate (3 días laborables desde hoy)
     ====================================================== */
  function updateDeliveryDate() {
    if (!deliveryDateEl) return;
    var d = new Date();
    var added = 0;
    while (added < 3) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    deliveryDateEl.textContent = 'Llega el ' + WEEKDAYS_ES[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS_ES[d.getMonth()];
  }
  updateDeliveryDate();

  /* ======================================================
     Announcement rotativa (3 mensajes · 4s cada uno)
     ====================================================== */
  (function initAnnouncements() {
    if (!announcements || announcements.length < 2) return;
    var current = 0;
    setInterval(function () {
      announcements[current].setAttribute('hidden', '');
      current = (current + 1) % announcements.length;
      announcements[current].removeAttribute('hidden');
    }, 4000);
  })();

  /* ======================================================
     Add-on protección envío · toggle
     On change → /cart/add.js o /cart/change.js qty=0
     ====================================================== */
  (function initAddon() {
    if (!addonInput) return;
    // Pull variant_id from Shopify settings via a data attr injected inline below
    var addonId = window.__TANDEM_ADDON_VARIANT_ID__ || '';
    if (!addonId) {
      addonInput.disabled = true;
      return;
    }
    addonInput.setAttribute('data-addon-id', addonId);

    addonInput.addEventListener('change', function () {
      addonInput.disabled = true;
      var promise;
      if (addonInput.checked) {
        promise = addToCart(addonId, 1);
      } else {
        // Remove by setting qty=0 on all lines matching
        promise = fetchCart().then(function (cart) {
          var line = (cart.items || []).findIndex(function (it) {
            return String(it.variant_id) === String(addonId) || String(it.id) === String(addonId);
          });
          if (line < 0) return cart;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: line + 1, quantity: 0 })
          }).then(function (r) { return r.json(); });
        });
      }
      promise
        .then(function () { return fetchCart(); })
        .then(renderCart)
        .catch(function (err) {
          console.warn('[cart] addon toggle error', err);
          addonInput.checked = !addonInput.checked;
        })
        .finally(function () { addonInput.disabled = false; });
    });
  })();

  /* ======================================================
     Discount code box colapsable
     On submit → /discount/{CODE}?redirect=/cart
     On return → ?discount_applied=1 → mostrar "aplicado"
     ====================================================== */
  (function initDiscount() {
    var toggle = drawer.querySelector('[data-discount-toggle]');
    var form = drawer.querySelector('[data-discount-form]');
    var input = drawer.querySelector('[data-discount-input]');
    var applied = drawer.querySelector('[data-discount-applied]');
    if (!toggle || !form || !input) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      form.hidden = expanded;
      if (!expanded) {
        setTimeout(function () { input.focus(); }, 50);
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (input.value || '').trim().toUpperCase();
      if (!code) return;
      // Redirect strategy: Shopify applies cookie + returns to /cart
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart%3Fdiscount_applied%3D' + encodeURIComponent(code);
    });

    // On return, check for query param
    var params = new URLSearchParams(window.location.search);
    if (params.get('discount_applied') && applied) {
      applied.hidden = false;
      form.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
  })();
})();
